export default "__VITE_ASSET__DqNYurq___"